import React, { useMemo } from 'react';
import { useAppContext } from '../../../Services/AppContext';
import { Meta, useWorkplacePartnerQuery } from '../../../graphql/graphql';
import { Partner } from '../Enums/Partner.enum';

const MINIMAL_PRICE_PER_COUNTRY: Record<string, number> = {
	//SOL (calculated from USD limit)
	peru: 2,
	//USD
	ecuador: 0.5,
	//MXN  (stripe defined)
	mexico: 10,
	//COP (calculated from USD limit)
	colombia: 2100,
	//PLN  (stripe defined)
	poland: 2,
	//HUF (stripe defined)
	hungary: 175,
	//RSD (calculated from USD limit)
	serbia: 55,
	//EUR  (stripe defined)
	slovakia: 0.5,
	//EUR  (stripe defined)
	slovenia: 0.5,
	//EUR  (stripe defined)
	germany: 0.5,
	//EUR  (stripe defined)
	greece: 0.5,
	//CZK  (stripe defined)
	default: 15,
};

export default function useScope() {
	const { globalTemplate, workplaceId } = useAppContext();
	const workplacePartner = useWorkplacePartnerQuery({
		id: workplaceId,
	});

	const isKDARWorkplace = useMemo(() => {
		return workplacePartner?.data?.workplace?.partnerId === Partner.KDAR;
	}, [workplacePartner]);

	const isUnicare = useMemo(() => {
		return workplacePartner?.data?.workplace?.partnerId === Partner.UNICARE;
	}, [workplacePartner]);

	const minimalPriceInputValue = useMemo(() => {
		return MINIMAL_PRICE_PER_COUNTRY[globalTemplate];
	}, [globalTemplate]);

	const countryCode: string = useMemo(() => {
		switch (globalTemplate) {
			case 'peru':
				return 'PE';
			case 'ecuador':
				return 'EC';
			case 'mexico':
				return 'MX';
			case 'colombia':
				return 'CO';
			case 'slovakia':
				return 'SK';
			case 'poland':
				return 'PL';
			case 'hungary':
				return 'HU';
			case 'greece':
				return 'GR';
			case 'serbia':
				return 'RS';
			case 'czechia':
			default:
				return 'CZ';
		}
	}, [globalTemplate]);

	const isHungary = globalTemplate === 'hungary';
	const isSlovakia = globalTemplate === 'slovakia';
	const isPoland = globalTemplate === 'poland';
	const isCzechia = globalTemplate === 'default';
	const isLatam = ['peru', 'ecuador', 'mexico', 'colombia'].includes(
		globalTemplate,
	);

	return {
		minimalPriceInputValue,
		isKDARWorkplace,
		isHungary,
		isSlovakia,
		isUnicare,
		isLatam,
		isPoland,
		isCzechia,
		countryCode,
	};
}
